module.exports = __webpack_public_path__ + "static/img/3063_phase_function_Paper_PointsHejduk_Prediction.73f24f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3063_phase_function_Paper_PointsHejduk_Prediction.png
// module id = JbN6
// module chunks = 0